import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { MeetingModel } from "api/meeting-model"


interface meetingState {
  meetingInfo: MeetingModel | null
  setMeetingInfo: (info: MeetingModel | null) => void
}

export default create<meetingState>()(
  persist(
    (setState) => ({
      meetingInfo: null,
      setMeetingInfo(info) {
        setState({ meetingInfo: info })
      }
    }),
    { name: 'meeting' }
  )
)

export type { meetingState }
